"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            submitting: false,
            suggestions: []
        };
        fhandler.bind(this);
    },
    onSearchResult: function (results) {
        this.state.suggestions = results.map(({profile, account}) => {
            return {
                poster: {
                    type: 'image',
                    value: profile.photo
                },
                title: getFullname(profile),
                subtitle: profile.email,
                status: (account.roles || []).filter(role => {
                    return role != 'USER';
                }).join(', ')
            };
        });
    },
    onSearchDismiss: function () {
        this.state.suggestions = [];
    },
    onSelectSuggestion: function (index) {
        fhandler.fill({
            fullname: this.state.suggestions[index].title,
            email: this.state.suggestions[index].subtitle
        });
    },
    onSubmit: async function () {
        const Form = this.state.form;
        if (!Form.email)
            return this.state.formError.email = true;
        if (!Form.accountType)
            return this.state.formError.accountType = true;
        this.state.submitting = true;
        try {
            const {error, message} = await Request('/invitation/send', 'POST', Form);
            this.state.submitting = false;
            fhandler.alert(message, error ? 'error' : 'success');
            if (error)
                return;
            fhandler.reset();
        } catch (error) {
            this.state.submitting = false;
            fhandler.alert(error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Apps/View.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    index_template = require("/workspace/src/views/components/Wrapper/index.marko"),
    module_FormHandler = require("markojs-form"),
    FormHandler = module_FormHandler.default || module_FormHandler,
    SearchBar_template = require("../../../components/SearchBar/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    Select_template = require("../../../components/Select/index.marko"),
    Select_tag = marko_loadTag(Select_template),
    get_context_template = require("@marko-tags/context/src/components/get-context/index.marko"),
    get_context_tag = marko_loadTag(get_context_template),
    FormAlert_template = require("../../../components/FormAlert/index.marko"),
    FormAlert_tag = marko_loadTag(FormAlert_template),
    Preloader_template = require("../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    Locale_template = require("../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Wrapper_Admin_template = require("../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "position-relative form-group",
        style: "z-index:10"
      },
    marko_attrs1 = {
        "class": "form-group"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("9eb093"),
    marko_node0 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "form-group"
      },
    marko_attrs3 = {
        "class": "font-small-4 text-right mt-2"
      },
    marko_attrs4 = {
        "class": "text-primary"
      };

const fhandler = new FormHandler({ key: 'add-user' });

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      class: "d-flex justify-content-center",
      renderBody: function(out, { page, themeMode }) {
        WSAdapt_tag({
            qs: "col-xl-6",
            hs: "col-xl-9",
            class: "col-xl-5 col-lg-7 col-md-10",
            renderBody: function(out) {
              out.be("form", null, "@add-user", component);

              out.t(" ");

              out.be("div", marko_attrs0, "2", component);

              SearchBar_tag({
                  size: "xl",
                  icon: "bx-user",
                  target: "user",
                  minLength: 3,
                  suggestions: state.suggestions,
                  placeholder: Locale("Find the user")
                }, out, __component, "3", [
                [
                  "blur",
                  "onSearchDismiss",
                  false
                ],
                [
                  "result",
                  "onSearchResult",
                  false
                ],
                [
                  "select",
                  "onSelectSuggestion",
                  false
                ]
              ]);

              out.ee();

              out.be("div", marko_attrs1, "4", component);

              Select_tag({
                  class: "rounded",
                  size: "xl",
                  value: state.form.accountType,
                  name: "accountType",
                  options: [
                      {
                          value: "admin",
                          label: "Administrator"
                        },
                      {
                          value: "instructor",
                          label: "Instructor"
                        },
                      {
                          value: "learner",
                          label: "Learner"
                        }
                    ],
                  placeholder: Locale("Account Permissions")
                }, out, __component, "5", [
                [
                  "select",
                  "__onChange",
                  false
                ]
              ]);

              out.ee();

              if (state.form.accountType == "admin") {
                out.be("div", marko_attrs2, "6", component);

                Select_tag({
                    class: "rounded",
                    size: "xl",
                    value: state.form.accountRole,
                    name: "accountRole",
                    options: [
                        {
                            value: "SUPER",
                            label: "SUPER ADMIN"
                          },
                        {
                            value: "SUPERVISOR",
                            label: "SUPERVISOR"
                          }
                      ],
                    placeholder: Locale("Administrator Role")
                  }, out, __component, "7", [
                  [
                    "select",
                    "__onChange",
                    false
                  ]
                ]);

                get_context_tag({
                    __from: index_template,
                    renderBody: function(out, emit) {
                      out.e("p", marko_attrs3, "8", component, 2)
                        .t("Learn more about Administrator ")
                        .e("span", marko_attrs4, "9", component, 1, 0, {
                            onclick: __component.d("click", emit, false, [
                                "onHelp",
                                "Topic-ID"
                              ])
                          })
                          .t("Roles & Permissions");
                    }
                  }, out, __component, "15");

                out.ee();
              }

              out.n(marko_node0, component);

              FormAlert_tag({
                  alert: state.alert
                }, out, __component, "11");

              out.be("button", {
                  type: "submit",
                  "class": "btn btn-primary btn-xl w-100",
                  disabled: state.submitting
                }, "12", component, null, 0, {
                  onclick: __component.d("click", "onSubmit", false)
                });

              Preloader_tag({
                  class: "float-right font-medium-5",
                  active: state.submitting
                }, out, __component, "13");

              Locale_tag({
                  text: "Save"
                }, out, __component, "14");

              out.ee();

              out.ee();
            }
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
